export default "/images/ava-def.svg?e6603916bd5eedbf576fccf46f7497c0";